import React, { Component } from 'react';
import HeaderNav from './common/HeaderNav';
import './styles/Number.css'
import { Link } from 'react-router-dom';
// import SideFilterBar from './common/SideFilterBar';
// search field
import TextField from '@mui/material/TextField';
// search button
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Button } from '@mui/material';
import queryString from 'query-string';
import apiCall from '../utils/apiCall';
import NumberBox from './common/NumberBox';
import styledComponents from './styles/styledComponents';
import Model from './common/Model';
import { connect } from "react-redux";
import { cartInfo } from './common/redux/actions';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

// import Box from '@mui/material/Box';
// import Modal from '@mui/material/Modal';

let mountLimit = 1;
let retryLimit = 1;
const {
  IconWhiteHover,
  Form,
  ButtonWrapper,
  ButtonSecondary,
  ButtonSuccess,
  Title,
  SubHeading
} = styledComponents;

class VerifyEmail extends Component {
  state = {
    verificationStatus: null,
  }


  async componentDidMount() {
    if (mountLimit == 1 || retryLimit == 2) {
      mountLimit++;
      try {

        if (window.location.search) {

          let queryParams = queryString.parse(window.location.search)
          let userId = queryParams.userId;

          const { result } = await apiCall('REACT_APP_VERIFY_EMAIL_URL', 'POST', {
            userId: parseInt(userId)
          })
          if (result && result['success'] && result['status']) {
            this.setState({ verificationStatus: true });
          } else {
            this.setState({ verificationStatus: false });
          }

        } else {
          window.location.href = '/'
        }

      } catch (error) {
        console.log('Home componentDidMount Error ::', error);
      }
      setTimeout(() => {
        mountLimit = 1;
      }, 500);
    }
  }

  renderSuccess = () => {
    return (
      <React.Fragment>
        <center>
          <div>
          <CheckCircleIcon sx={{ mt: 12, fontSize: 100, color: "green" }} />
            <h1>
              Verifcation SuccessFull
            </h1>
          </div>
          <Link className='view-orders'
            to={"/login"}
          >
            <Button className='btn-loadmore'>LogIn</Button>
          </Link>
        </center>
      </React.Fragment>
    )
  }

  renderFailed = () => {
    return (
      <React.Fragment>
        <center>
          <div>
            <CancelIcon sx={{ mt: 9, fontSize: 100, color: "red" }} />
            <h1>
              Verifcation Failed or User is already verified, please retry or contact admin
            </h1>

          </div>
          <Link className='view-orders'
            to={"/login"}
          >
            <Button className='btn-loadmore'>Login</Button>
          </Link>
          <Link className='view-orders'
            to={"/"}
          >
            <Button className='btn-loadmore'>HOME</Button>
          </Link>
        </center>
      </React.Fragment>
    )
  }


  render() {

    console.log('this.state ===============>', this.state);
    console.log('this.props ===============>', this.props);

    return (
      <React.Fragment>
        <div id="mainNumbersContainer">

          {/* render Header Nav Bar */}
          <HeaderNav />

          <div id="subMainContainer" style={{ flexDirection: 'column' }}>

            {
              this.state.verificationStatus === true
                ? this.renderSuccess()
                : this.state.verificationStatus === false
                  ? this.renderFailed()
                  : ''
            }
          </div>
        </div>

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return { state }
}

export default connect(mapStateToProps, { cartInfo })(VerifyEmail);